import { render, staticRenderFns } from "./employee-revenue.component.vue?vue&type=template&id=78149144&scoped=true&"
import script from "./employee-revenue.component.vue?vue&type=script&lang=ts&"
export * from "./employee-revenue.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-revenue.component.vue?vue&type=style&index=0&id=78149144&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78149144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol,VDataTable,VIcon,VRow})
